import styled from 'styled-components';

const DefaultLogo = styled.div`
  margin-bottom: 24px;
`;

export default DefaultLogo;
